export const commonFoods = [
  'Oatmeal (plain, rolled oats)',
  'White rice',
  'Brown rice',
  'Quinoa',
  'Whole wheat bread',
  'White bread',
  'Sweet potato',
  'Pasta (white)',
  'Pasta (whole wheat)',
  'Berries (mixed)',
  'Apple',
  'Banana',
  'Orange',
  'Grapes',
  'Chicken breast',
  'Salmon',
  'Eggs',
  'Greek yogurt',
  'Almonds',
  'Broccoli',
  'Spinach',
  'Carrots',
  'Chips (potato)',
  'Cookies',
  'Candy',
  'Soda',
  'Juice (100%)',
];

export const isProtocolBuilderStepValid = (
  activeStep: number,
  hasSelectedPatient: boolean,
  protocolTitle: string,
  startDate: string,
  classificationsCount: number
) => {
  switch (activeStep) {
    case 0:
      return hasSelectedPatient;
    case 1:
      return protocolTitle.trim() !== '' && startDate.trim() !== '';
    case 2:
      return classificationsCount > 0;
    case 3:
      return true;
    case 4:
      return true;
    default:
      return false;
  }
};
